import Cookies from "js-cookie";


export const isAuthenticate = () => {
    if (typeof window === undefined) {
        return false;
    }

    if (Cookies.get("fast_pay_acc")) {
        return Cookies.getJSON("fast_pay_acc");
    } else {
        return false;
    }
};
